import Vue from 'vue';
import Router from 'vue-router';
import Plates from '@/components/Plates';
import Login from '@/components/Login';
import SignUp from '@/components/SignUp';
import firebase from 'firebase';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/login',
    },
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/plates',
      name: 'plates',
      component: Plates,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/sign-up',
      name: 'signup',
      component: SignUp,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // If we aren't yet logged in and we need to be authenticated to access
  // the url, send the user to the login page
  if (requiresAuth && !currentUser) next('/login');

  // If we don't need auth and we do have a current user (we are already signed)
  // in, then send the user to the main page for the app
  else if (!requiresAuth && currentUser) next('/plates');
  else next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js